module.exports = __webpack_public_path__ + "static/media/mastercard.0d0a1be4.svg";